import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { AccountMenuComponent } from './layout/account-menu/account-menu.component';

@Component({
  selector: 'ez-root',
  imports: [NavbarComponent, RouterOutlet, AccountMenuComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
